import 'css-chunksrc/client/common/memberAvatar/styles.scss';export default {
  "zoneAvatar": "_zoneAvatar_19l3c_1"
};